import { useState, FormEvent } from 'react';

interface FD { name: string; email: string; company: string; phone: string; monthly_budget: string; }

export default function CTASection() {
  const [fd, setFd] = useState<FD>({ name: '', email: '', company: '', phone: '', monthly_budget: '' });
  const [sub, setSub] = useState(false);
  const [ok, setOk] = useState(false);

  const change = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
    setFd(p => ({ ...p, [e.target.name]: e.target.value }));

  const submit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSub(true);
    try {
      const p = new URLSearchParams();
      Object.entries(fd).forEach(([k, v]) => p.append(k, v));
      await fetch('https://readdy.ai/api/form/d7151drk1jkj467r58vg', {
        method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: p.toString(),
      });
      setOk(true);
      setFd({ name: '', email: '', company: '', phone: '', monthly_budget: '' });
    } catch {/* silent */} finally { setSub(false); }
  };

  return (
    <section id="contact" className="py-10 md:py-24 bg-[#07091A] relative overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-neon/25 to-transparent"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-neon/6 rounded-full blur-[100px] pointer-events-none"></div>

      <div className="relative z-10 max-w-2xl mx-auto px-5 md:px-8 text-center">
        {/* Headline */}
        <div className="mb-7 md:mb-10">
          <p className="text-neon text-xs md:text-sm font-bold tracking-widest uppercase mb-3 md:mb-4 leading-relaxed">마지막 기회</p>
          <h2 className="font-black font-display text-white mb-3 md:mb-2"
            style={{ fontSize: 'clamp(1.7rem, 7vw, 4rem)', lineHeight: 1.2 }}>
            상담 비용 0원<br />
            <span style={{ color: '#00FF87' }}>지금 바로 확인하세요</span>
          </h2>
          <p className="text-white/35 text-xs md:text-base leading-relaxed">
            계약 강요 없음 · 숨겨진 비용 없음<br className="block md:hidden" />· 24시간 내 응답
          </p>
        </div>

        {/* Form */}
        <div className="rounded-xl md:rounded-2xl overflow-hidden text-left" style={{
          border: '1px solid rgba(0,255,135,0.2)',
          boxShadow: '0 0 60px rgba(0,255,135,0.08)',
        }}>
          <div className="bg-neon px-5 md:px-8 py-4 md:py-5 flex items-center justify-between gap-3">
            <div className="min-w-0">
              <p className="text-[#07091A] font-black text-base md:text-xl font-display leading-snug">
                지금 무료로<br className="block md:hidden" />광고 진단 받기
              </p>
              <p className="text-[#07091A]/55 text-xs md:text-sm mt-1 leading-relaxed">
                30초 입력 · 24H 내<br className="block md:hidden" />전문가 연락
              </p>
            </div>
            <div className="bg-[#07091A]/10 rounded-xl px-3 md:px-4 py-2 text-center flex-shrink-0">
              <div className="text-[#07091A] font-black text-xl md:text-2xl font-display leading-none">0원</div>
              <div className="text-[#07091A]/50 text-xs mt-0.5">상담비</div>
            </div>
          </div>

          <div className="bg-[#0D1128] p-5 md:p-8">
            {ok ? (
              <div className="text-center py-8 md:py-10">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-neon/20 rounded-full flex items-center justify-center mx-auto mb-5">
                  <i className="ri-check-double-line text-neon text-2xl md:text-3xl"></i>
                </div>
                <p className="text-white font-black text-lg md:text-xl font-display mb-2">신청 완료!</p>
                <p className="text-white/40 text-sm leading-relaxed mb-5 md:mb-6">24시간 내 담당 마케터 연락드립니다.</p>
                <button onClick={() => setOk(false)}
                  className="bg-neon hover:bg-neon-dim text-[#07091A] font-bold px-5 md:px-6 py-2.5 rounded-xl transition-colors cursor-pointer whitespace-nowrap text-sm">
                  다시 신청하기
                </button>
              </div>
            ) : (
              <form onSubmit={submit} data-readdy-form className="space-y-3">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <input type="text" name="name" value={fd.name} onChange={change} required placeholder="이름 *"
                    className="w-full bg-[#0A0D1E] border border-white/10 focus:border-neon text-white placeholder-white/25 rounded-xl px-4 py-3.5 text-sm leading-relaxed transition-colors outline-none" />
                  <input type="tel" name="phone" value={fd.phone} onChange={change} required placeholder="연락처 *"
                    className="w-full bg-[#0A0D1E] border border-white/10 focus:border-neon text-white placeholder-white/25 rounded-xl px-4 py-3.5 text-sm leading-relaxed transition-colors outline-none" />
                </div>
                <input type="email" name="email" value={fd.email} onChange={change} required placeholder="이메일 *"
                  className="w-full bg-[#0A0D1E] border border-white/10 focus:border-neon text-white placeholder-white/25 rounded-xl px-4 py-3.5 text-sm leading-relaxed transition-colors outline-none" />
                <input type="text" name="company" value={fd.company} onChange={change} required placeholder="회사명 *"
                  className="w-full bg-[#0A0D1E] border border-white/10 focus:border-neon text-white placeholder-white/25 rounded-xl px-4 py-3.5 text-sm leading-relaxed transition-colors outline-none" />
                <select name="monthly_budget" value={fd.monthly_budget} onChange={change} required
                  className="w-full bg-[#0A0D1E] border border-white/10 focus:border-neon text-white rounded-xl px-4 py-3.5 text-sm transition-colors outline-none cursor-pointer">
                  <option value="" className="bg-[#07091A]">월 광고비 예산 *</option>
                  <option value="100만원 이하" className="bg-[#07091A]">100만원 이하</option>
                  <option value="100~300만원" className="bg-[#07091A]">100~300만원</option>
                  <option value="300~500만원" className="bg-[#07091A]">300~500만원</option>
                  <option value="500~1000만원" className="bg-[#07091A]">500~1000만원</option>
                  <option value="1000만원 이상" className="bg-[#07091A]">1000만원 이상</option>
                </select>
                <button type="submit" disabled={sub}
                  className="w-full bg-neon hover:bg-neon-dim text-[#07091A] font-black py-4 md:py-5 rounded-xl transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2.5 text-base md:text-lg disabled:opacity-60">
                  {sub ? <><i className="ri-loader-4-line animate-spin text-xl"></i>신청 중...</> :
                    <>지금 무료로 광고 진단 받기 <i className="ri-arrow-right-line text-xl"></i></>}
                </button>
                <p className="text-center text-white/20 text-xs leading-relaxed">
                  상담 비용 0원 · 스팸 없음<br className="block md:hidden" />· 정보 보호
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
